<template>
  <div class="date-picker">
    <tc-date-picker
      ref="datePickerRef"
      v-model="model"
      :validation-state="resolveValidationState"
      :validation-message="resolveValidationMessage"
      :label="label"
      :options="options" />
    <span
      class="icon"
      @click="openCalendar">
      <img src="@/assets/calendar_thin.svg"></span>
  </div>
</template>

<script>
import { defineComponent, computed, onMounted, watch } from '@vue/composition-api'
import TcDatePicker from '@telia/tc-date-picker'
import { getValidationMessage, getValidationState, ValidationState } from '@/utils/validation.utils'

export default defineComponent({
  components: {
    TcDatePicker
  },
  props: {
    options: {
      type: Object
    },
    value: {
      type: String,
      default: null
    },
    label: {
      type: String
    },
    validator: {
      type: Object
    },
    validationMessage: {
      type: String
    },
    validationState: {
      type: String
    }
  },
  /* istanbul ignore next */
  setup (props, { emit, refs }) {
    const model = computed({
      get: () => props.value,
      set: (val) => emit('input', val)
    })

    const openCalendar = () => refs.datePickerRef.flatpickrInstance.toggle()

    const resolveValidationState = computed(() => props.validator ? getValidationState(props.validator) : props.validationState)
    const resolveValidationMessage = computed(() => props.validator ? getValidationMessage(props.validator, props.validationMessage) : props.validationMessage)

    onMounted(() => {
      const flatPickerInstance = refs.datePickerRef.flatpickrInstance

      const isFlatPickerOpen = computed(() => flatPickerInstance && flatPickerInstance.isOpen)

      watch(() => isFlatPickerOpen.value, (isOpen) => {
        const renderedCalendar = document.getElementsByClassName('flatpickr-calendar')[0]

        if (isOpen && renderedCalendar) {
          renderedCalendar.style.display = 'block'
        } else if (renderedCalendar) {
          renderedCalendar.style.display = 'none'
        }
      }, { immediate: true })
    })

    return {
      resolveValidationState,
      resolveValidationMessage,
      ValidationState,

      model,
      openCalendar
    }
  }
})
</script>
<style lang="scss" scoped>

.date-picker {
  position: relative;

  .icon {
    position: absolute;
      right: 5%;
      top: 54px;
      transform: translateY(-50%);
      cursor: pointer;
  }

// workaround for tc white label bug
  /deep/ label {
    background-color: transparent !important;
  }
}
</style>
